import { CommApiInstance } from "Utils/CommApiInstance";


const MembGameRelLstApi = async (
) => {
    return await CommApiInstance.post(`memb/game_rel_lst`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data.apiBody);
}

export default MembGameRelLstApi;